import React from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Autocomplete, Checkbox, Grid } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import TextField from "@mui/material/TextField";
import { useEffect, useState, Fragment } from "react";
import AvatarImage from "../../Avatar/AvatarImage";
import convertTipoStanzaToKeysI18n from "../../../functions/DataTable/convertTipoStanzaToNameDataTable";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../functions/Utils/capitalizeFirstLetter";

export function AutocompleteCustom({
  label = "Default Label",
  field = ["id"],
  checkField = "id",
  keyId = "id",
  optionsAutoComplete = [],
  multiple = false,
  handleValueReturned = () => null,
  isDisabled = false,
  disableCloseOnSelect,
  fullWidth = true,
  startValueAutoComplete = multiple ? [] : {},
  errorMsg = "",
  clean = false,
  mostraAvatar = true,
  cleanAlways, //permette il reload 
}) {
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(multiple ? [] : {});
  const { t } = useTranslation();

  useEffect(() => {
    handleValueReturned(selectedValue);
  }, [selectedValue]);


  useEffect(() => {
    setOptions(optionsAutoComplete);
    setSelectedValue(startValueAutoComplete);
  }, [optionsAutoComplete]);

  const handleChangeObjSelect = (event, value) => {
    setSelectedValue(value);
  };

  useEffect(() => {
    if (clean) setSelectedValue(null);
  }, [clean, cleanAlways]);

  return (
    <React.Fragment>
      <Autocomplete
        disabled={isDisabled}
        multiple={multiple}
        id="roles"
        size="small"
        disableCloseOnSelect={disableCloseOnSelect ?? multiple}
        options={options}
        value={selectedValue}
        limitTags={1}
        fullWidth={fullWidth}
        isOptionEqualToValue={(option, value) =>
          option[checkField] === value[checkField]
        }
        getOptionLabel={(option) =>
          field
            .map((field, index) => {
              const optionField =
                field === "sigla" ? "(" + option[field] + ")" : option[field]; //da Dinamicizzare
              return option[field] === undefined ? "" : optionField;
            })
            .join(" ")
        }
        onChange={handleChangeObjSelect}
        renderOption={(props, option, { selected }) => (
          <Grid container {...props} key={option[keyId]}>
            <div>{options[keyId]?.firstName}</div>
            { multiple && <Checkbox
                key={option[keyId]}
                icon={
                  <CheckBoxOutlineBlankIcon
                    key={option[keyId]}
                    fontSize="small"
                  />
                }
                checkedIcon={
                  <CheckBoxIcon key={option[keyId]} fontSize="small" />
                }
                style={{ marginRight: 8 }}
                checked={selected}
              />
            }
            {mostraAvatar && <div style={{ marginRight: "10px" }}>
              <AvatarImage
                size={33}
                isInputDisabled={true}
                isCentered={false}
                isUserLoggedImage={false}
                ImmagineAvatar={option.immagineAvatar}
                name={option.firstName + " " + option.lastName}
              ></AvatarImage>
            </div>}
            {field.map((field, index) => {
              const optionField =
                field === "sigla" ? "(" + option[field] + ")" : option[field]; //da Dinamicizzare
              return <Fragment key={index}>{optionField} </Fragment>;
            })}
            {(option.idTipologiaStanza && !option.posto) && <Fragment><Grid item xs={12} style={{ marginLeft: '3rem', fontSize: '0.8rem', color: '#3e6bb4', display: "block" }}>
              {capitalizeFirstLetter(t(convertTipoStanzaToKeysI18n(option.idTipologiaStanza).titleDataTable))}
            </Grid></Fragment>}
          </Grid>
        )}
        renderInput={(params) => (
          <TextField
            error={errorMsg === "" ? false : true}
            helperText={errorMsg}
            {...params}
            label={label}
            variant="standard"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>{params.InputProps.endAdornment}</Fragment>
              ),
            }}
          />
        )}
      />
    </React.Fragment>
  );
}
